import memoizeOne from 'memoize-one';

import { LOCAL, DEVMAJ, MAJSTG, PRD } from '../constants/environments';

const hostNameEnvMapping = {
  'local-template-cms.sunrundev.com': LOCAL,
  'devmaj-template-cms.sunrundev.com': DEVMAJ,
  'majstg-template-cms.sunrun.com': MAJSTG,
  'template-cms.sunrun.com': PRD,
};

const getEnv = () => hostNameEnvMapping[window.location.hostname] || LOCAL;

export default memoizeOne(getEnv);
